import { defineStore } from 'pinia';
import { defaultAppConfig } from '@/src/config/defaults';
import type { AppConfig } from '@/src/config/schema';
import type { FeatureId } from '../../profiles/profile.schema';

export const useAppConfigStore = defineStore('app-config', {
  state: (): AppConfig => ({
    ...defaultAppConfig,
  }),
  getters: {
    anonymize: (state) => state.privacy.anonymize,
    isFeatureEnabled:
      (state) =>
      (feature: FeatureId): boolean =>
        state.features[feature],
  },
  actions: {
    init(config: AppConfig) {
      this.privacy = config.privacy;
      this.features = config.features;
    },
  },
});

export function initAppConfigStore(config: AppConfig) {
  useAppConfigStore().init(config);
}
